import { render, staticRenderFns } from "./NeighbourhoodLabelsItemLine.vue?vue&type=template&id=2bcd90ca&scoped=true&"
import script from "./NeighbourhoodLabelsItemLine.vue?vue&type=script&lang=js&"
export * from "./NeighbourhoodLabelsItemLine.vue?vue&type=script&lang=js&"
import style0 from "./NeighbourhoodLabelsItemLine.vue?vue&type=style&index=0&id=2bcd90ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd90ca",
  null
  
)

export default component.exports